import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  error: null,
};

export default reducerFactory(initialState, {
  [types.CREATE_GB_SUBMISSION_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.CREATE_DE_SUBMISSION_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.CREATE_GB_SUBMISSION_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    response: response.submission,
  }),
  [types.CREATE_GB_SUBMISSION_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.CREATE_DE_SUBMISSION_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    response: response.submission,
  }),
  [types.CREATE_DE_SUBMISSION_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
});
